import { useState } from "react";
import { api, errorText } from "@/lib/api";

const FIELDS = [
  ["login", "Login", "text", "4-16 znaków, litery i cyfry"],
  ["email", "E-mail", "email", ""],
  ["password", "Hasło", "password", "6-16 znaków"],
  ["password2", "Powtórz hasło", "password", ""],
  ["social_id", "Kod usuwania postaci", "text", "7 cyfr - zapamiętaj go!"],
];
const empty = { login: "", email: "", password: "", password2: "", social_id: "", website: "" };

const Field = ({ name, label, type, hint, value, onChange }) => (
  <label className="block">
    <span className="text-[11px] tracking-[0.25em] text-slate-500">{label}</span>
    <input type={type} value={value} onChange={onChange} required data-testid={`register-${name}-input`}
      className="steel-input" />
    {hint && <span className="text-[11px] text-slate-400 mt-1 block">{hint}</span>}
  </label>
);

export default function RegisterForm({ onSuccess }) {
  const [form, setForm] = useState(empty);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await api.post("/register", form);
      onSuccess(form.login); setForm(empty);
    } catch (err) { setError(errorText(err)); } finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="space-y-5" data-testid="register-form">
      {FIELDS.map(([k, l, t, hint]) => <Field key={k} name={k} label={l} type={t} hint={hint} value={form[k]} onChange={set(k)} />)}
      <input tabIndex={-1} autoComplete="off" value={form.website} onChange={set("website")} className="hidden" aria-hidden="true" />
      {error && <p className="text-sm text-red-300" data-testid="register-error">{error}</p>}
      <button disabled={busy} className="btn btn-primary w-full" data-testid="register-submit-btn">
        {busy ? "Tworzenie konta..." : "Zarejestruj"}
      </button>
    </form>
  );
}
